import Moment from "moment/moment";

export function formatVideoSeconds(currentTime) {
  if (currentTime == null || currentTime === "") {
    return "";
  }
  const time = Number(currentTime);
  if (Number.isNaN(time)) {
    return currentTime;
  }
  const d = new Date();
  d.setSeconds(Math.floor(time));
  d.setMilliseconds(Math.floor((time % 1) * 1000));
  return Moment(d).format("s.SSS");
}
